// Lynk.id storefront where customers complete their tier purchase. The
// resulting webhook is processed by POST /api/v1/webhooks/lynkid on the
// backend. Single source of truth for the FE — change here, change everywhere.
const DEFAULT_LYNK_SLUG = 'izzr4';
const lynkSlug = import.meta.env.VITE_LYNK_PURCHASE_SLUG || DEFAULT_LYNK_SLUG;

export const LYNK_PURCHASE_URL = `https://lynk.id/${lynkSlug}`;
